import script from "./CutoutsConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./CutoutsConfiguration.vue?vue&type=script&setup=true&lang=ts"

import "./CutoutsConfiguration.vue?vue&type=style&index=0&id=f7f0105c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f0105c"]])

export default __exports__